import ColorPickerContainer from './ColorPickerContainer';

export default ColorPickerContainer;